<template>
    <h3 id="header">
      How MagnetQR works...  
    </h3>
    <ol id="howitworks">
      <li>Go to one of the <a href="#">Partner Souvenir Shops</a> and buy a MagnetQR!</li>
      <li>Scan the QR-Code on the magnet!</li>
      <li>Enter your personal text!</li>
    </ol>
    <h4>Everytime, someone reopens the QR code of your magnet, they are able to read your message! Use it...</h4>
    <ul id="usage">
      <li>...as a present from abroad for your beloved ones.</li>
      <li>...as a souvenir to remind you of perfect times.</li>
    </ul>
    <h3>Try it now!</h3>
</template>

<script>
export default {
  name: 'About',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#header {
    margin: 5% 5% 5% 5%;
}
#howitworks {
  margin: 5% 5% 5% 0;
  font-size: 130%;
}
#howitworks li {
  margin: 0 0 5% 0;
}
#usage {
  margin: 5% 5% 5% 0;
  font-size: 130%;
  list-style: none;
}
#usage li {
  margin: 0 0 5% 0;
}

</style>